import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "intercom-launcher",
  class: "text-lg font-bold text-primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("button", _hoisted_1, " Help "))
}